<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="list__title">
          <h2>Danh sách đấu giá viên</h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="list__user" v-for="item in auctioneerList" :key="item.id">
          <div class="user__left">
            <img :src="getImage(item.avatar)" alt="" />
          </div>
          <div class="user__right">
            <div class="user__name">
              <h4>{{ item.name }}</h4>
            </div>
            <div class="user__info">
              <span class="user__label user__label--full pd-l">Chứng chỉ hành nghề (Do Bộ Tư pháp cấp) :</span>
              <span class="user__label user__label--m-full pd-m">Số chứng chỉ :</span
              ><span class="user__value pd-l">{{ item.certificateOfPracticeNumber }}</span>
              <span class="user__label user__label--m-full pd-m">Ngày cấp :</span
              ><span class="user__value">{{ item.certificateOfPracticeDate }}</span>
            </div>
            <div class="user__info">
              <span class="user__label pd-l user__label--full">Thẻ đấu giá viên (Do Sở Tư pháp Hà Nội cấp) :</span>
              <span class="user__label user__label--m-full pd-m">Số thẻ :</span
              ><span class="user__value pd-l">{{ item.auctionCardNumber }}</span>
              <span class="user__label user__label--m-full pd-m">Ngày cấp :</span
              ><span class="user__value">{{ item.auctionCardDate }}</span>
            </div>
            <div class="user__detail">
              {{ item.description }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixins/mixin.js';

import auctioneerList from '@/data/auctioneers.json';
export default {
  name: 'Auctioneers',
  mixins: [mixin],
  data() {
    return {
      auctioneerList
    };
  },
  methods: {
    getImage(avatar) {
      return require(`@/assets/images/${avatar}`);
    }
  }
};
</script>

<style scoped>
table,
th,
td {
  border: 1px solid #e6e6e6;
}
td,
th {
  padding: 10px 15px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Auctioneers.vue